import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class FastPhonicsLessonsController extends Controller {
  queryParams = ['filterPhase']

  @tracked filterPhase = ''
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/lessons/fast-phonics': FastPhonicsLessonsController
  }
}
